import { render, staticRenderFns } from "./TileCombo.vue?vue&type=template&id=9534e638&scoped=true&"
import script from "./TileCombo.vue?vue&type=script&lang=js&"
export * from "./TileCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9534e638",
  null
  
)

export default component.exports